import React from 'react'

const ThemeContext = React.createContext({
  activeThemeIsLight: true,
  toChangeTheme: () => {},
  savedVideos: [],
  toSaveVideo: () => {},
})
export default ThemeContext
